import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const ZoomIn = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='m20 20-3.873-3.873m0 0A7.25 7.25 0 1 0 5.874 5.874a7.25 7.25 0 0 0 10.253 10.253M11 7.75v6.5M14.25 11h-6.5'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    ) : (
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3 11a8 8 0 1 1 14.162 5.102l3.369 3.368a.75.75 0 1 1-1.06 1.06l-3.37-3.368A8 8 0 0 1 3 11m8.75-3.25a.75.75 0 0 0-1.5 0v2.5h-2.5a.75.75 0 0 0 0 1.5h2.5v2.5a.75.75 0 0 0 1.5 0v-2.5h2.5a.75.75 0 0 0 0-1.5h-2.5z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
